<template>
  <div class="boilerplate-item mb-3">
    <!-- REPO TITLE -->
    <h2>{{ item.title }}</h2>

    <!-- REPO STATS -->
    <h4 class="h5 mb-2">
        <i class="fa fa-star mr-2" aria-hidden="true"></i>{{ item.star_count }}
        <i class="fa fa-eye mr-2 ml-4" aria-hidden="true"></i>{{ item.watch_count }}
        <i class="fa fa-code-fork mr-2 ml-4" aria-hidden="true"></i> {{ item.fork_count }}
    </h4>
    
    <!-- REPO LAST UPDATED -->
    <p>
        <small><strong>Last updated</strong> {{ itemdata.updated_at | timeSince }}</small>
    </p>

    <!-- REPO DESCRIPTION -->
    <p>{{ item.description }}</p>
    
    <!-- REPO LINKS -->
    <p class="boilerplate-links mb-0 mt-2">
        <a v-bind:href="item.url" target="_blank" class="btn btn-primary align-items-center mr-2">
            <i class="fa fa-github mr-2" aria-hidden="true"></i>
            View Repository
        </a>
        <a v-bind:href="item.zip_url" target="_blank" class="btn btn-primary">
            <i class="fa fa-file-archive-o mr-2" aria-hidden="true"></i>
            Download
        </a>
    </p>

    <!-- REPO LANGUAGES
    <p v-if="item.languages != null">
        <strong>Repo languages:</strong><br/>
        <span v-for="(language, index) in item.languages">
            {{ language }}
        </span>
    </p>-->
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
const moment = require('moment')

export default {
    name: 'boilerplateitem',
    components: {  },
    props: ['itemdata', 'type'],
    data () {
        return {
            item: {
                'title': null,
                'url': null,
                'type': null,
                'categories': null,
                'short_description': null,
                'watch_count': null,
                'star_count': null,
                'fork_count': null
            }
        }
    },
    mounted(){
        // build item object from 'itemdata' prop
        this.item = {
            'title': this.itemdata.name,
            'url': this.itemdata.html_url,
            'description': this.itemdata.description,
            'watch_count': this.itemdata.watchers_count,
            'star_count': this.itemdata.stargazers_count,
            'fork_count': this.itemdata.forks_count,
            //'languages': this.itemdata.languages_url,
            'last_updated': this.itemdata.pushed_at,
            'zip_url': 'https://github.com/' + this.itemdata.full_name + '/archive/master.zip'
        } 
        // call API to get repo code languages (after 0.5s delay)
        /*setTimeout(() => {
            axios.get(this.item.languages)
            .then(function (response) {
                this.item.languages = response.data.items
            })
            .catch(function (error) {
                console.log(error);
            });  
        }, 500)*/
    },
    methods: {
    },
    filters: {
        formatDate: function (date) {
            if (date) {
                return moment(date).format('DD/MM/YYYY hh:mm')
            }
        },
        timeSince: function (date) {
            if (date) {
                return moment(date).fromNow()
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  $gutter: 1.25rem;

  .boilerplate-item {
      transition: background-size 750ms ease-in 250ms;
      padding: $gutter;
      &:after {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: darken(#172B4D, 2.5%);
        opacity: 0;
        transition: opacity 300ms ease-in-out 50ms;
        display: inline-block;
        z-index: -1;
    }
    &:hover {
        &:after {
            opacity: 1;
        }
    }  
  }


  .boilerplate-links {
      .fa {
          vertical-align: top;
          font-size: 1.5rem;
      }
      .btn {
          line-height: 1.5rem;
      }
  }

</style>




// WEBPACK FOOTER //
// boilerplate-item.vue?26651bbc